import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useSupliers = create((set, get) => ({
    supliers: [],
    ed: {},
    setEd: (ed) => set({ ed }),
    suplier: {},
    setSuplier: (suplier) => set({ suplier }),
    // `first_name`, `last_name`, `mobile`, `address`, `balance`, `status`
    columns: [
        {
            title: 'Familya',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Ismi',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Telefon',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: 'Balansi (+ qarz, - ortiqcha summa)',
            dataIndex: 'balance',
            key: 'balance',
        },
        {
            title: 'Manzil',
            dataIndex: 'address',
            key: 'address',
        },
    ],
    fetchSupliers: async () => {
        try {
            const response = await axios.get('/suppliers');
            set({ supliers: response.data });
        } catch (error) {
            console.error('Error fetching supliers:', error);
        }
    },
    addSuplier: async (suplier) => {
        try {
            await axios.post('/suppliers', suplier);
            get().fetchSupliers();
            message.success('Mijoz muvaffaqiyatli qo`shildi');
        } catch (error) {
            console.error('Error adding suplier:', error);
        }
    },
    updateSuplier: async (suplier) => {
        try {
            await axios.put(`/suppliers/${suplier.id}`, suplier);
            get().fetchSupliers();
            message.success('Mijoz muvaffaqiyatli tahrirlandi');
        } catch (error) {
            console.error('Error updating suplier:', error);
        }
    },
    deleteSuplier: async (_, id) => {
        try {
            await axios.delete(`/suppliers/${id.id}`);
            get().fetchSupliers();
            message.success('Mijoz muvaffaqiyatli o`chirildi');
        } catch (error) {
            console.error('Error deleting suplier:', error);
        }
    },
}));